export default function AtlasLogo(){return <img src="/logo.png" alt="Entretien Net Pro — nettoyage commercial et résidentiel" className="brand-logo" />;}